<div class="ui-g dashboard-map-container">
  <div id="tripMap" class="map"></div>
</div>